import {PRODUCTS_BILLING_SCHEMES} from '../const';

const getHumanReadablePrice = amount => {
  const price = amount / 100;
  return Number.isInteger(price) ? price : price.toFixed(2).replace('.', ',');
};

function calculateTieredPricingDetails(quantity, tiers) {
  let total = 0;
  let previousLimit = 0;
  const breakdown = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const tier of tiers) {
    const upTo = tier.up_to;
    const unitAmount = tier.unit_amount;

    const isLastTier = upTo === null;
    const tierLimit = isLastTier ? quantity : Math.min(quantity, upTo);
    const unitsInTier = tierLimit - previousLimit;

    if (unitsInTier > 0) {
      const subtotal = unitsInTier * unitAmount;
      total += subtotal;
      breakdown.push({units: unitsInTier, unitAmount, subtotal});
      previousLimit = tierLimit;
    }

    if (quantity <= tierLimit) break;
  }

  return {total, breakdown};
}

const calculateProductPrice = (product, quantity) => {
  if (!product) return 0;

  if (product.billing_scheme === PRODUCTS_BILLING_SCHEMES.TIERED) {
    const {total} = calculateTieredPricingDetails(quantity, product.tiers);
    return total;
  }

  if (product.transform_quantity) {
    const nextQuantityStep = Math.ceil(quantity / product.transform_quantity.divide_by);
    return product.amount * nextQuantityStep;
  }

  return product.amount * quantity;
};

const calculateAverageProductPrice = (product, quantity) => {
  const totalPrice = calculateProductPrice(product, quantity); // in cents
  const averageInEuros = totalPrice / quantity / 100;
  return parseFloat(averageInEuros.toFixed(2));
};

export {getHumanReadablePrice, calculateProductPrice, calculateAverageProductPrice, calculateTieredPricingDetails};
